<template>
    <div class="ag-theme-alpine" >
        <ag-grid-vue
        :class="{'ag-grid-content': true}"
        :columnDefs="columnDefs"
        :rowData="rowData"
        :gridOptions="gridOptions"
        @grid-ready="onGridReady"
        class="ag-theme-alpine">
    </ag-grid-vue>
    <!-- <button @click="deleteSelectedRows" class="btn btn-danger m-2">Delete Selected Rows</button> -->
    <button @click="exportDataToCsv" class="btn btn-info m-2">Export to CSV</button>

</div>
</template>
<script>
import { AgGridVue } from 'ag-grid-vue';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import API from '../api'; 

export default {
    components: {
        AgGridVue
    },
    data() {
        return {
            gridApi: null,
            gridColumnApi: null,
            columnDefs: [
                { headerName: "User Name", field: "user_name", sortable: true, filter: true, editable: true, flex: 1 },
                { headerName: "Comment", field: "comment", sortable: true, filter: true, editable: true, flex: 1 },
                { headerName: "Event Type", field: "event_type", sortable: true, filter: true, editable: true, flex: 1 },
                { headerName: "Molecular Trait id", field: "molecular_trait_id", sortable: true, filter: true, flex: 1 },
                { headerName: "Credible Set", field: "credible_set", sortable: true, filter: true, flex: 1 },
                { headerName: "Variant ID", field: "variant", sortable: true, filter: true, flex: 1 },
                { headerName: "ID_1", field: "id_1", sortable: true, filter: true, width: 100 },
                { headerName: "ID_2", field: "id_2", sortable: true, filter: true, width: 100 },
            ],
            gridOptions: {
                defaultColDef: {
                    resizable: true
                },
                rowHeight: 23,
                rowSelection: 'multiple',
            },
            rowData: [],
        };
    },
    methods: {
        exportDataToCsv() {
            this.gridApi.exportDataAsCsv();
        },
        onGridReady(params) {
            this.gridApi = params.api;
            this.gridColumnApi = params.columnApi;
        },
    },
    mounted() {
        API.getAllComments().then(data => {
            this.rowData = data.comments;
            if (this.gridApi) {
                this.gridApi.setRowData(this.rowData);
            }
        });
    }
};
</script>

<style scoped>
.ag-theme-alpine {
    height: 80vh;
}

</style>